<template>
<main class="row onboarding-wrapper">
    <div class="col-md-12 ob-rightcol"  v-if="!loadingInvitation && invitationObj">
        <template v-if="!invitationObj.previouslyAccepted && !invitationObj.existingMember && !invitationObj.expired">
            <div class="primary-heading" >
                Boom! You’re in.
            </div>
            <div class="mt-2 secondary-heading mt-1">
                Please create an account password to complete setting up your agent profile.
            </div>
            <div class="state-agent">
                <div class="sa-frm-row  mb-0 mt-3" >
                    <div class="sa-form-control ">
                        <input class="sa-control" placeholder="Create Password" type="password" @keyup="resetError" v-model = "password"/>
                    </div>
                    <div v-if="errorText == 'enterPassword'" class="sa-label error-text" style="text-align:left;">Please enter password</div>
                    <div v-if="errorText == 'wrongFormat'" class="sa-label error-text" style="text-align:left;">Password does not match all the criteria mentioned at the bottom.</div>
                </div>
                <div class="sa-frm-row  mb-0 mt-2" >
                    <div class="sa-form-control ">
                        <input class="sa-control" placeholder="Re-enter Password" type="password" @keyup="resetError" v-model = "rePassword"/>
                    </div>
                    <div v-if="errorText == 'enterRePassword'" class="sa-label error-text" style="text-align:left;">Please re-enter password </div>
                    <div v-if="errorText == 'passwordNoMatch'" class="sa-label error-text" style="text-align:left;">Both passwords should be same.</div>
                </div>
                <!-- <div class="sa-frm-row  mb-0 mt-2" >
                    <div class="sa-label error-text" style="text-align:left;color:#6b6e70">* Password must contain atleast 6 letters, atleast one uppercase letter, atleast one lowercase letter, atleast one digit and should not contain any spaces.</div>
                </div> -->
                <div class="sa-frm-row  " >
                    <div class="ob-btn-wrapper" style="border-top:none;">
                        <button v-if="!loadingInvitation"   class="ob-button" style = "align-items:center" @click="updateInvitation" >Save Password</button>
                        <div  v-if="loadingInvitation" class="rotate-btn-wrap" style = "align-items:center">
                            <div class="loader"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-4 region-info-text" style="text-align:left;max-width:350px;">
                <span class="secondary-heading">Minimum Password Requirements:</span>
                <ul style="margin-top:15px;">
                    <li>8 Characters</li>
                    <li>One Uppercase Letter</li>
                    <li>One Lowercase Letter</li>
                    <li>One Number</li>
                    <li>No Spaces</li>
                </ul>
            </div>
        </template>
        <template v-else-if="!newInvitationSent && (invitationObj.previouslyAccepted || invitationObj.existingMember)">
            <ExistingUser :userName="invitationObj.invitation.sentTo.title.split(' ')[0]"></ExistingUser>
        </template>
        <template v-else>
            <div class="primary-heading text-capitalize">
                Welcome, {{invitationObj.invitation.sentTo.title.split(' ')[0]}}!
            </div>
            <div class="email-img-wrap">
                <img src="@/assets/images/newui/email_plcaholder.png" alt="">
            </div>
            <div class="secondary-heading mt-4" v-if="!newInvitationSent && invitationObj.expired && !invitationObj.existingMember" >
                This invitation has expired. Please <a @click="reInviteAgent" class="link">click</a> here to send a new one.
            </div>

            <div class="secondary-heading mt-4" v-if="newInvitationSent" >
                We just sent an new email to you. Please check.
            </div>
        </template>
        <PrivacyPolicy v-if="showPrivacyPopup" @closePopup="closePopup"/>
        <WorbixTermsPopup v-if="showTermsPopup" @closePopup="closePopup"/>
        <div id="panelBackdrop" v-if="showPrivacyPopup || showTermsPopup"></div>
    </div>
    <div class="loader-spinner"  v-if="loadingInvitation"></div>
</main>
</template>

<script>
// @ is an alias to /src
import AgentLogo from '@/components/agent-logo.vue'
import FooterLeft from '@/components/footer-left.vue'
import ExistingUser from '@/components/ExistingUser.vue'
import PrivacyPolicy from '@/components/PrivacyPolicy.vue'
import WorbixTermsPopup from '@/components/WorbixTermsPopup.vue'
import Multiselect from 'vue-multiselect'
import passwordValidator from 'password-validator'
import {
	serverUrl,
	worbixServerUrl,
    appEnv
} from '../properties';
export default {
    name: 'State',
    components: {
        AgentLogo,
        FooterLeft,
		Multiselect,
        WorbixTermsPopup,
        PrivacyPolicy,
        ExistingUser
    },
	data(){
		return{
			selectedOffice:{},
			officeList	:[],
			code:null,
            password:null,
            rePassword:null,
            invitationObj:null,
            termsOfService:false,
            errorText:'',
            newInvitationSent:false,
            personId:null,
            loginLink:null,
            showTermsPopup:false,
            showPrivacyPopup:false,
            loadingInvitation:false
		}
	},
	mounted(){
        this.code = this.$route.params.code
		this.fetchInvitation();
        this.loginLink = worbixServerUrl;

	},
	methods:{
        closePopup(){
            this.showPrivacyPopup = false;
            this.showTermsPopup = false;
        },
        async reInviteAgent(){
            this.loadingInvitation = true;
            await this.$store.dispatch("reInviteAgent", {invitationId : this.invitationObj.invitation.id});
            this.loadingInvitation = false;
            this.newInvitationSent = true;
        },
		async fetchInvitation(){
			let payload = {
				code : this.code,
			}
            this.loadingInvitation = true;
			let res = await this.$store.dispatch("fetchInvitation", payload);
            this.loadingInvitation = false;
            this.invitationObj = res;
		},
        updateInvitation(){
            if (!this.password) {
                this.errorText = 'enterPassword'
                return;
            }

            let schema = new passwordValidator();
            schema
            .is().min(8)                                    // Minimum length 6
            .is().max(100)                                  // Maximum length 100
            .has().uppercase()                              // Must have uppercase letters
            .has().lowercase()                              // Must have lowercase letters
            .has().digits(1)                                // Must have at least 1 digits
            .has().not().spaces()                           // Should not have spaces
            //.is().not().oneOf(['Passw0rd', 'Password123']); // Blacklist these values

            let validatePassword  = schema.validate(this.password, { list: true })
            if (validatePassword.length) {
                this.errorText = 'wrongFormat'
                return;
            }

            if (!this.rePassword) {
                this.errorText = 'enterRePassword'
                return;
            }
            if (this.password != this.rePassword) {
                this.errorText = 'passwordNoMatch'
                return;
            }

            let payload = {...this.invitationObj};
            payload.code = this.code;
            payload.disableOtherSpaces = true;
            payload.user.password = this.password;
            payload.user.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            payload.fullName = payload.invitation.title;
            payload.currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            this.loadingInvitation = true;
            console.log({payload});
			this.$store.dispatch("verifyInvitation", payload).then((res) => {
                this.personId = res.actor.contact.id;
                this.notifyAdmin(res.actor.contact);
                this.$router.push({path:'/setupProfile/'+ this.personId});
                // this.authorizeUser();
			})
        },
        async notifyAdmin(contact){
            let agentInfo = {}
            agentInfo['Full Name'] = contact.title;
            let basicProfile = contact.profiles.find((item)=>{
                return item.type == 'com.worbix.model.BasicProfile';
            })
            let emails = basicProfile.emails;
            if (emails.length) {
                agentInfo['Email'] = emails[0].email;
            }

            let mailContent = `<b>A user with below information has registered with us.</b>
            ${Object.keys(agentInfo).map( (row) => {
                return `<p>${row} : ${agentInfo[row] ? agentInfo[row] : '-'}<p> \n`
                }
            ).filter(function (el) {
                return el != null;
            }).join('')}`
            console.log({mailContent});

            let payload = {}
            payload['mailContent'] = mailContent;
            let res = await this.$store.dispatch("notifyAdmin", payload);
        },
        authorizeUser(){
            let payload = {}
            payload['userName'] = this.invitationObj.user.email;
            payload['password'] = this.password;
            this.$store.dispatch("authenticateUser", payload).then((res) => {
                this.loadingInvitation = false;
                this.setCookie(res)
                this.$router.push({path:'/setupProfile/'+ this.personId});
			})
        },
        setCookie(authRes){
            console.log('cookiedata', authRes);
            let authProp = authRes.worbixAccessToken.subject.properties;
            document.cookie = `tokenKey=${authRes.worbixAccessToken.tokenKey}`;
            document.cookie = `currentUser=${authRes.worbixAccessToken.subject.login}`;
            authProp.forEach((item, i) => {
                document.cookie = `${item.name} = ${item.value}`
            });
        },
        resetError(){
            this.errorText = '';
        }
	}
}
</script>

<style lang="scss">
.cursor-pointer{
    cursor: pointer;
}
.error-wrapper{
    text-align: left;
    color: #ffffff;
    background-color: #db082b;
    border-color: #a00620;
    padding: 15px;
    border-radius: 4px;
    width: 500px;
    font-size: 25px;
    position: fixed;
    bottom: 20px;
    right: 20px;
    padding-top: 25px;
}

.error-wrapper .fa{
    position: absolute;
    right: 8px;
    top: 5px;
    cursor: pointer;
}
a:not([href]).link{
    text-decoration: underline;
    color: #007bff;
    cursor: pointer;
    &:hover{
        text-decoration: underline;
        color: #007bff;
    }
}
.multiselect.form-control.multi-dropdown {
	padding: 0;
	height: auto;
}
.multi-select .multiselect.form-control.multi-dropdown {
    border: 1 #e1e1e1 solid;
	height:98px
}

.multi-select .multiselect__tags{
	border:0px;
	font-size:14px;
	font-family:inherit;
	height:98px
}

.multi-select .multiselect__select{
	height:98px
}

.multi-select .multiselect__single{
	font-size:45px;
	color:#666666;
	font-weight:300;
	display: inline-flex;
	align-items: center;
	height:100%;
	overflow:hidden;
	white-space: nowrap;
}

.multi-select .multiselect__input{
	font-size:45px;
	color:#666666;
	font-weight:300;
	height:100%
}

.multi-select .multiselect__element{
	color:#666666;
}

.multi-select .multiselect__option{
    font-size: 1.25rem;
}

.error-text{
    color: #ff0000;
    float: left;
    font-size: 25px;
}

</style>
